/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Modal, Input, Form, message } from 'antd';

const AddCustomCourse = (props) => {
  const {
    visible,
    onCancel,
    hiddenDescription = false, // 是否隐藏课程描述，默认为false
    onOk,
    courseInfo,
  } = props;
  const [courseName, setCourseName] = useState('');
  const [description, setDescription] = useState('');
  const [label, setLabel] = useState('');

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  useEffect(() => {
    if (courseInfo) {
      setCourseName(courseInfo.courseName);
      setDescription(courseInfo.description);
      setLabel(courseInfo.label);
    }
  }, [courseInfo]);

  function clickOnOkAction() {
    if (courseName === '' || !courseName) {
      return message.error('课程名称未填');
    } else if (!hiddenDescription && (description === '' || !description)) {
      return message.error('课程描述未填');
    } else if (label === '' || !label) {
      return message.error('训练部位未填');
    }

    if (hiddenDescription) {
      onOk(courseName, label);
    } else {
      onOk(courseName, description, label);
    }
  }

  function courseNameChange(e) {
    setCourseName(e.target.value);
  }

  function courseDetailChange(e) {
    setDescription(e.target.value);
  }

  function trainPartChange(e) {
    setLabel(e.target.value);
  }

  return (
    <Modal
      open={visible}
      width={600}
      title={courseInfo?.courseName ? '编辑课程' : '新建课程'}
      cancelText={'取消'}
      okText={'确认'}
      onCancel={onCancel}
      onOk={clickOnOkAction}
    >
      <Form {...formItemLayout}>
        <Form.Item
          label={
            <span>
              <span style={{ color: 'red', marginRight: 5 }}>*</span>课程名称
            </span>
          }
        >
          <Input.TextArea
            maxLength={30}
            showCount
            allowClear
            autoSize={true}
            placeholder="请输入"
            onChange={courseNameChange}
            value={courseName}
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              <span style={{ color: 'red', marginRight: 5 }}>*</span>课程描述
            </span>
          }
          hidden={hiddenDescription}
        >
          <Input.TextArea
            // maxLength={30}
            // showCount
            allowClear
            autoSize={true}
            placeholder="请输入"
            onChange={courseDetailChange}
            value={description}
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              <span style={{ color: 'red', marginRight: 5 }}>*</span>训练部位
            </span>
          }
        >
          <Input.TextArea
            // maxLength={30}
            // showCount
            allowClear
            autoSize={true}
            placeholder="请输入"
            onChange={trainPartChange}
            value={label}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCustomCourse;
